import pagination from '../components/components-items/pagination.vue';



// 为组件添加 install 方法，用于按需引入
pagination.install = function (Vue) {
    Vue.component(pagination.name, pagination)
}




export default pagination